/**
 * 
 * @param this 组建的实例
 * @param Array 检测参数
 this.$validate(this, [
    {
        value: 'username',
        msg: '请填写用户名'
    },
    {
        value: 'password',
        msg: '请填写登录密码'
    },
    {
        value: 'address',
        child: ['age', 'name'], // 验证address对象的属性值,数组或者是单一字符串(类型须和msg字段保持一致)
        msg: ['请填写年龄'] 
    }
])
 * 
 * @export
 * @class Validate
* */
export default class Validate {
    _Vue
    constructor(Vue) {
        this._Vue = Vue
    }
    valid(scope, options) {
        let msg
        for (let opt of options) {
            if (opt.child) {
                if (opt.child instanceof String) {  
                    if (!scope[opt.value][opt.child]) {
                        msg = opt.msg
                        break
                    }
                }
                if (opt.child instanceof Array) {
                    if (!(opt.msg instanceof Array)) {
                        msg = `检测属性 {${opt.value}} 的msg值必须为数组类型`
                        break
                    }
                    for (let i = 0, l = opt.child.length; i < l; i++) {
                        if (!scope[opt.value][opt.child[i]]) {
                            msg = opt.msg[i]
                            break
                        }
                    }
                }
            } else {  
                if (!scope[opt.value]) {
                    msg = opt.msg
                    break
                }
            }
        }
        if (msg) {
            this._Vue.prototype.$message.warning(msg)
            return false
        }
        return true
    }
}


// WEBPACK FOOTER //
// ./src/plugins/validate/validate.js